
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import OtherNews from "~/components/news/OtherNews";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";
import {pickSeoTitle} from "~/helpers/seo-title";

export default {
  fetch: async function () {
    await this.getCitiesList();
    await this.getArticle();
  },

  head: function () {
    const articleTitle = `${(this.article?.title || '').trim()}`;

    if (!articleTitle) {
      return {
        title: "Новость не найдена - Central Trans",
        meta: [
          { hid: 'metadescription', name: 'description', content: '' },
          { hid: 'og:description', name: 'og:description', property: 'og:description', content: '' }
        ],
      }
    }

    const citiesKnown = Boolean(this.infoCityFrom && this.infoCityTo);
    // H1/SEO-заголовок приоритетнее шаблона «Перевезли … по маршруту …»:
    // шаблон при обрезке по лимиту теряет конец фразы и даёт дубли title.
    const title = pickSeoTitle([
      this.article?.seo_title,
      articleTitle,
      citiesKnown ? this.seoTemplateTitle : null,
    ], 80);
    const description = this.seoTemplateDescription || this.article?.seo_description || this.buildDefaultDescription();

    return {
      __dangerouslyDisableSanitizers: ['script', 'innerHTML'],

      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: String(JSON.stringify(this.newsArticleSchema) || '')
        }
      ]
    }
  },

  data: function () {
    return {
      article: {}
    }
  },

  computed: {
    datePublished: function () {
      let date = new Date((this.article.date || '').split(".").reverse().join("-"));
      return date.toLocaleDateString('ru-RU', {
        day: "2-digit",
        month: "long",
        year: 'numeric'
      })
    },

    seoTemplateTitle: function () {
      const template = this.$store.state.appState?.vars?.['SEO шаблон для страницы новости (заголовок)'] || "";
      if (!template) {
        return
      }

      return this.fillTemplate(template)
    },
    seoTemplateDescription: function () {
      const template = this.$store.state.appState?.vars?.['SEO шаблон для страницы новости (сообщение)'] || "";
      if (!template) {
        return
      }

      return this.fillTemplate(template)
    },

    articleContent: function () {
      const content = this.article?.content || "";

      return content.replace(/<h1[^>]*>[\s\S]*?<\/h1>/gi, "")
    },

    newsArticleSchema: function () {
      if (!this.article?.title) {
        return
      }

      const published = this.article?.publish_from
        ? new Date(this.article.publish_from * 1000).toISOString()
        : undefined;
      const image = this.article?.image_id
        ? `${this.$img(String(this.article.image_id))}`
        : undefined;

      return {
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        'mainEntityOfPage': {
          '@type': 'WebPage',
          '@id': `https://centraltrans.ru${this.$route.fullPath}`
        },
        'headline': `${(this.article?.seo_title || this.article?.title || '').trim()}`,
        'image': image,
        'datePublished': published,
        'dateModified': published,
        'author': {
          '@type': 'Organization',
          'name': 'Central Trans',
          'url': 'https://centraltrans.ru/'
        },
        'publisher': {
          '@type': 'Organization',
          'name': 'Central Trans',
          'logo': {
            '@type': 'ImageObject',
            'url': 'https://centraltrans.ru/favicon.svg'
          }
        },
        'description': this.seoTemplateDescription || this.article?.seo_description || this.buildDefaultDescription()
      }
    },

    breadcrumbs: function () {
      return [
        { title: "Главная", path: "/" },
        { title: "Наш опыт", path: "/news" },
        { title: this.article?.title, path: this.$route.fullPath },
      ]
    },
    userCity: function () {
      const city = this.$store.state?.appState?.config?.city?.data?.parental || this.$store.state?.appState?.config?.city?.data?.city_name;

      return `из ${city}`
    },
    tagsLinks: function () {
      return (this.article?.tags || [])
        .map((t) => {
          return {
            ...t,
            url: `/news?page=1&filter[tag_id]=${ t.id }`
          }
        })
    },

    cmsPageNews: function () {
      return Number.parseFloat(this.$store.state.appState?.vars?.['ID CMS страницы для новости'] || '')
    },
    feedbackFormBlockValue: function () {
      return {
        imageId: this.article.feedback_form_block_image
      }
    },
    articlesBlockValue: function () {
      return {
        tags: (this.article?.tags || []).map((t) => t.id),
        exceptions: [this.article?.id],
        isApi: true
      }
    },

    tableInformation: function () {
      let list = [];

      if (this.article?.info_cargo) {
        list.push({
          title: "Груз",
          value: this.article?.info_cargo,
          icon: require("~/assets/img/svg/news/cargo.svg")
        })
      }
      if (this.article?.info_transport) {
        list.push({
          title: "Транспорт",
          value: this.article?.info_transport,
          icon: require("~/assets/img/svg/news/transport.svg")
        })
      }
      if (this.infoCityFrom) {
        list.push({
          title: "Откуда",
          value: this.infoCityFrom,
          icon: require("~/assets/img/svg/news/from.svg")
        })
      }
      if (this.article?.info_delivery_period) {
        list.push({
          title: "Срок доставки",
          value: this.article?.info_delivery_period,
          icon: require("~/assets/img/svg/news/delivery-period.svg")
        })
      }
      if (this.infoCityTo) {
        list.push({
          title: "Куда",
          value: this.infoCityTo,
          icon: require("~/assets/img/svg/news/to.svg")
        })
      }
      if (this.article?.info_distance_km) {
        list.push({
          title: "Расстояние (км)",
          value: this.article?.info_distance_km,
          icon: require("~/assets/img/svg/news/distance.svg")
        })
      }

      return list
    },

    citiesList: function () {
      return this.$store.state["city-select"]?.citiesList || {}
    },

    infoCityTo: function () {
      const cities = this.citiesList?.cities || [];
      return cities.find((t) => Number.parseFloat(t.id) === Number.parseFloat(this.article?.info_city_to))?.name || this.article?.info_city_to_text || ""
    },
    infoCityFrom: function () {
      const cities = this.citiesList?.cities || [];
      return cities.find((t) => Number.parseFloat(t.id) === Number.parseFloat(this.article?.info_city_from))?.name || this.article?.info_city_from_text || ""
    },
    infoTransportCompletionDate: function () {
      if (!this.article?.info_transport_completion_date) {
        return
      }

      const today = new Date(Number.parseFloat(this.article?.info_transport_completion_date) * 1000)

      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      return dd + '.' + mm + '.' + yyyy
    },

    cmsPageIdContent: function () {
      const pageId = this.article?.cms_page_id || null;
      if (!pageId) {
        return null
      }
      return Number.parseFloat(pageId)
    }
  },

  components: {
    Breadcrumbs,
    OtherNews
  },

  mounted: function () {
    this.removeDuplicateH1();
  },

  methods: {
    fillTemplate: function (text) {
      const values = {
        '*груз*': this.article?.info_cargo,
        '*откуда*': this.infoCityFrom,
        '*куда*': this.infoCityTo,
        '*дата*': this.infoTransportCompletionDate,
        '*срок доставки*': this.article?.info_delivery_period,
        '*расстояние*': this.article?.info_distance_km,
        '*транспорт*': this.article?.info_transport,
      };

      return Object.keys(values).reduce((result, token) => {
        const value = values[token];

        return result.split(token).join(value === undefined || value === null ? '' : String(value));
      }, text)
        // «по маршруту - от …» / «по маршруту - » при пустых городах
        .replace(/\s+по маршруту\s+-\s+(?=от(?:[^а-яё]|$))/gi, ' ')
        .replace(/\s+по маршруту\s+-\s*(?=$|[,;.])/gi, '')
        .replace(/\s+/g, ' ')
        .replace(/\s+([,.;])/g, '$1')
        .replace(/([,.;])([,.;])/g, '$1')
        .replace(/,\s*\./g, '.')
        .replace(/\s+-\s*\./g, '.')
        .replace(/\s+-\s*$/g, '')
        .trim()
    },

    buildDefaultDescription: function () {
      const announce = `${(this.article?.announce || '').trim()}`;

      if (announce) {
        return announce.slice(0, 240)
      }

      return `${(this.article?.title || '').trim()}. Новости и выполненные перевозки компании Central Trans.`.slice(0, 240)
    },

    // В CMS-контенте может лежать собственный <h1>, из-за чего на странице
    // получалось два H1. Убираем дубли, совпадающие с заголовком новости.
    removeDuplicateH1: function () {
      if (!process.client || !this.$el) {
        return
      }

      const title = `${(this.article?.title || '').trim()}`;
      const blocks = this.$el.querySelectorAll('.article-page__cms-content, .article-page__content');

      blocks.forEach((block) => {
        block.querySelectorAll('h1').forEach((el) => {
          if (!title || `${(el.textContent || '').trim()}` === title) {
            el.remove()
          }
        })
      })
    },

    getArticle: async function () {
      const slug = this.$route?.params?.slug;
      const article = await this.$api.agent.transport.get(`/articles/${ slug }?category_slug=news&expand=image,category,tags`).then((res) => {
        return res.data
      }).catch((err) => {
        return null
      });
      if (!article) {
        this.$nuxt.error({
          statusCode: 404,
          message: "Новость не найдена"
        });
        return
      }
      this.article = article;
      this.isUrlWithId();
    },
    getCitiesList: async function () {
      if (Object.keys(this.citiesList).length > 0) {
        this.isLoad = false;

        return
      }

      const response = await this.$api.agent.transport.get('cities').then((res) => {
        return res.data
      }).catch(() => {
        return {}
      });
      this.$store.commit("city-select/setCitiesList", response);
      this.isLoad = false;
    },

    openImage: function () {
      this.$store.commit("pop-up-images/setOpen", {
        images: [this.article.image_id]
      })
    },

    // редирект через 301, т.к по id страница тоже доступна, для сео
    // ВАЖНО: путь абсолютный и с защитой от перехода на себя — раньше отдавался
    // относительный слаг, из-за чего клиент уходил на ту же страницу и попадал
    // в бесконечную перезагрузку (инцидент 29.10.2026)
    isUrlWithId: function () {
      const article = this.article;

      if (!article || !article.id || !article.slug) {
        return;
      }

      const segment = String(this.$route.path || '').split('/').filter(Boolean).pop() || '';

      if (segment !== String(article.id) || String(article.slug) === segment) {
        return;
      }

      return this.$nuxt.context.redirect(301, `/news/${article.slug}`);
    },
  },
};
